import { useState } from 'react';

const shareItems = [
  { id: 'share', icon: 'ri-share-forward-line', label: '分享' },
  { id: 'bookmark', icon: 'ri-bookmark-line', label: '收藏' },
  { id: 'print', icon: 'ri-printer-line', label: '打印' },
];

export default function SubscribeBand() {
  const [followed, setFollowed] = useState(false);
  const [toast, setToast] = useState('');

  const handleShare = (label: string) => {
    setToast(`已选择「${label}」，本页为静态展示，不会真的跳转`);
  };

  return (
    <section id="subscribe" className="relative w-full overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=abstract%20dark%20textured%20background%20with%20subtle%20crimson%20and%20amber%20glow%2C%20film%20grain%2C%20minimal%20elegant%20composition%2C%20cinematic%20lighting&width=1600&height=700&seq=heliao51-band-10&orientation=landscape"
          alt="关注黑料51速递"
          title="黑料51吃瓜速递 关注入口"
          className="h-full w-full object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/75 via-black/55 to-black/35" />
      </div>

      <div className="relative w-full px-4 py-16 md:px-8 md:py-24">
        <div className="mx-auto flex max-w-6xl flex-col items-start gap-8 lg:flex-row lg:items-center lg:justify-between">
          <div data-reveal className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-3 py-1.5 text-xs text-background-50 backdrop-blur md:text-sm">
              <i className="ri-notification-3-line text-accent-300" />
              黑料51吃瓜速递
            </span>
            <h2 className="mt-5 font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
              新料一出，先看到的那批人永远是最从容的
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-200 md:text-base">
              不用填手机号，也不用注册账号。关注之后把这一页收藏起来，每天花五分钟就能把吃瓜热点和现场爆料一次过完。
            </p>
          </div>

          <div data-reveal data-reveal-delay="120" className="w-full max-w-md shrink-0">
            <div className="rounded-lg border border-white/20 bg-white/10 p-5 backdrop-blur md:p-6">
              <div className="flex flex-col gap-3 sm:flex-row">
                <button
                  type="button"
                  onClick={() => {
                    setFollowed(!followed);
                    setToast(followed ? '已取消关注（演示）' : '已关注速递，新料会排在最前面（演示）');
                  }}
                  className={`inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md px-5 py-3 text-sm font-medium transition-colors cursor-pointer ${
                    followed
                      ? 'bg-secondary-500 text-background-50 hover:bg-secondary-600'
                      : 'bg-primary-500 text-background-50 hover:bg-primary-600'
                  }`}
                >
                  <i className={followed ? 'ri-check-line' : 'ri-add-line'} />
                  {followed ? '已关注速递' : '立即关注速递'}
                </button>
                <a
                  href="#top"
                  className="inline-flex flex-1 items-center justify-center gap-2 whitespace-nowrap rounded-md border border-white/30 px-5 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-white/15 cursor-pointer"
                >
                  <i className="ri-arrow-up-line" />
                  回到首屏
                </a>
              </div>

              <div className="mt-5 flex items-center justify-between border-t border-white/15 pt-5">
                <span className="text-xs text-background-200 md:text-sm">顺手扩散一下</span>
                <div className="flex items-center gap-2">
                  {shareItems.map((item) => (
                    <button
                      key={item.id}
                      type="button"
                      onClick={() => handleShare(item.label)}
                      aria-label={item.label}
                      className="flex h-9 w-9 items-center justify-center rounded-md bg-white/10 text-background-50 transition-colors hover:bg-white/25 cursor-pointer"
                    >
                      <i className={`${item.icon} text-lg`} />
                    </button>
                  ))}
                </div>
              </div>

              <p className="mt-4 min-h-[20px] text-xs text-accent-200">{toast}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}